import { Grid } from "@mui/material";
import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";

class JobOutItemEntry extends Component {
  state = {
    ItemName: [],
    Packing: [],
    TaxName: [],
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Job Out Item Entry";
    this.props.setActiveMenu("JobOutItemEntry");
  }
  //#endregion Component
  render() {
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Job Out Item Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="txtOrderNo"
              label="Item Sr. No."
              maxLength={10}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbItemName"
              label="Item Name"
              onKeyDown={this.props.onKeyDown}
              items={this.state.ItemName}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbPacking"
              label="Packing"
              onKeyDown={this.props.onKeyDown}
              items={this.state.Packing}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtOrderNo"
              label="Quantity"
              maxLength={10}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtTxt id="txtOrderNo" label="Rate" maxLength={10} width={160} />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtOrderNo"
              label="Basic Amt"
              maxLength={10}
              width={160}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt id="txtOrderNo" label="Dis (%)" maxLength={10} width={160} />
          </Grid>
          <Grid item>
            <CtTxt id="txtOrderNo" label="Dis Amt" maxLength={10} width={160} />
          </Grid>
          <Grid item>
            <CtTxt id="txtOrderNo" label="Taxable" maxLength={10} width={160} />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbTaxName"
              label="Tax Name"
              onKeyDown={this.props.onKeyDown}
              items={this.state.TaxName}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtTxt id="txtOrderNo" label="CGST" maxLength={10} width={160} />
          </Grid>
          <Grid item>
            <CtTxt id="txtOrderNo" label="SGST" maxLength={10} width={160} />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt id="txtOrderNo" label="IGST" maxLength={10} width={160} />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtOrderNo"
              label="Total Amount"
              maxLength={10}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              maxLength={1500}
              width="330"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtBtn label="Add Item" />
          </Grid>
          <Grid item>
            <CtBtn label="New Item" />
          </Grid>
          <Grid item>
            <CtBtn label="Remove" />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(withRouter(JobOutItemEntry));
